
import { create } from "zustand";
import type { DiscoveryFilters, PaginationState } from "@/marketing/models/influencer";

interface FilterStore {
  filters: DiscoveryFilters;
  pagination: PaginationState;
  setSearch: (search: string) => void;
  setNotSelected: (value: boolean) => void;
  setMinFollowers: (value: number | null) => void;
  setEngRateMin: (value: number | null) => void;
  setCountryCodes: (countryCodes: string[]) => void;
  setLanguages: (languages: string[]) => void;
  setHasEmail: (value: boolean | null) => void;
  setPlatform: (platform: string) => void;
  setPageIndex: (pageIndex: number) => void;
  setPageSize: (pageSize: number) => void;
  resetFilters: () => void;
}

const DEFAULT_FILTERS: DiscoveryFilters = {
  search: "",
  notSelected: true,
  minFollowers: null,
  engRateMin: null,
  countryCodes: [],
  languages: [],
  hasEmail: null,
  platform: "tiktok",
};

const DEFAULT_PAGINATION: PaginationState = {
  pageIndex: 0,
  pageSize: 50,
};

export const useFilterStore = create<FilterStore>((set) => ({
  filters: DEFAULT_FILTERS,
  pagination: DEFAULT_PAGINATION,

  setSearch: (search) =>
    set((state) => ({
      filters: { ...state.filters, search },
      pagination: { ...state.pagination, pageIndex: 0 },
    })),

  setNotSelected: (notSelected) =>
    set((state) => ({
      filters: { ...state.filters, notSelected },
      pagination: { ...state.pagination, pageIndex: 0 },
    })),

  setMinFollowers: (minFollowers) =>
    set((state) => ({
      filters: { ...state.filters, minFollowers },
      pagination: { ...state.pagination, pageIndex: 0 },
    })),

  setEngRateMin: (engRateMin) =>
    set((state) => ({
      filters: { ...state.filters, engRateMin },
      pagination: { ...state.pagination, pageIndex: 0 },
    })),

  setCountryCodes: (countryCodes) =>
    set((state) => ({
      filters: { ...state.filters, countryCodes },
      pagination: { ...state.pagination, pageIndex: 0 },
    })),

  setLanguages: (languages) =>
    set((state) => ({
      filters: { ...state.filters, languages },
      pagination: { ...state.pagination, pageIndex: 0 },
    })),

  setHasEmail: (hasEmail) =>
    set((state) => ({
      filters: { ...state.filters, hasEmail },
      pagination: { ...state.pagination, pageIndex: 0 },
    })),

  setPlatform: (platform) =>
    set((state) => ({
      filters: { ...state.filters, platform },
      pagination: { ...state.pagination, pageIndex: 0 },
    })),

  setPageIndex: (pageIndex) =>
    set((state) => ({
      pagination: { ...state.pagination, pageIndex },
    })),

  setPageSize: (pageSize) =>
    set((state) => ({
      pagination: { ...state.pagination, pageSize, pageIndex: 0 },
    })),

  resetFilters: () =>
    set({ filters: DEFAULT_FILTERS, pagination: DEFAULT_PAGINATION }),
}));
